import { ApiUserDataAdapter } from './../interface/ApiUserDataAdapter'
import { ApiUserDataResponse } from './../interface/ApiUserDataResponse'
export const apiUserDataAdapter = ({ id, role, name, email }: ApiUserDataResponse): ApiUserDataAdapter => ({
  id,
  level: role,
  name,
  email
})
